import React from 'react'

export default function DataManagePage() {
    return (
        <div style={{ maxWidth: "900px", margin: "40px auto", padding: "0 20px", lineHeight: "1.7" }}>
            <h1>Adatkezelési tájékoztató</h1>

            <h2>1. Az adatkezelő adatai</h2>
            <p><strong>Weboldal neve:</strong> FociFanatik</p>
            <p><strong>Weboldal címe:</strong> https://focifanatik.hu</p>
            <p><strong>Kapcsolattartó e-mail:</strong> info@focifanatik.hu</p>

            <h2>2. Kezelt adatok köre</h2>
            <ul>
                <li>felhasználónév</li>
                <li>e-mail cím</li>
                <li>jelszó (titkosított formában)</li>
                <li>a regisztráció időpontja</li>
            </ul>

            <h2>3. Az adatkezelés célja</h2>
            <ul>
                <li>felhasználói fiók létrehozása és kezelése</li>
                <li>bejelentkezés biztosítása</li>
                <li>kapcsolattartás a felhasználóval</li>
                <li>a weboldal biztonságos működtetése</li>
            </ul>

            <h2>4. Az adatkezelés jogalapja</h2>
            <p>
                Az adatkezelés jogalapja az érintett önkéntes hozzájárulása,
                amelyet a regisztráció során ad meg.
            </p>

            <h2>5. Az adatok tárolásának időtartama</h2>
            <p>
                A személyes adatokat addig kezeljük, amíg a felhasználói fiók aktív,
                vagy amíg a felhasználó nem kéri adatainak törlését.
            </p>

            <h2>6. Adattovábbítás</h2>
            <p>
                A weboldal üzemeltetője a személyes adatokat harmadik félnek nem adja át,
                kivéve jogszabályi kötelezettség esetén.
            </p>

            <h2>7. Adatbiztonság</h2>
            <p>
                Megfelelő technikai és szervezési intézkedéseket alkalmazunk a személyes
                adatok védelme érdekében.
            </p>

            <h2>8. Az érintettek jogai</h2>
            <ul>
                <li>tájékoztatás kérése</li>
                <li>adatok helyesbítése vagy törlése</li>
                <li>adatkezelés korlátozása</li>
                <li>hozzájárulás visszavonása</li>
            </ul>
            <p>
                Kapcsolat: <strong>info@focifanatik.hu</strong>
            </p>

            <h2>9. Jogorvoslat</h2>
            <p>
                Panasz esetén a Nemzeti Adatvédelmi és Információszabadság Hatóságnál (NAIH)
                lehet eljárást kezdeményezni.
            </p>

            <h2>10. Záró rendelkezések</h2>
            <p>
                Az adatkezelő fenntartja a jogot a tájékoztató módosítására.
                A mindenkor hatályos verzió a weboldalon érhető el.
            </p>
        </div>
    )
}
